export default {
      id: "jpg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#jpg",
      toString: function () {
        return this.url;
      }
    }